module.exports = __webpack_public_path__ + "static/flatart-ai-header-menu-6d9d630f565cc9bd6f173161a07598b9.webp";